import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ConnectAccountDialog } from 'components/required-checklist/required-items/ConnectAccountDialog';
import * as RequiredItem from 'components/required-checklist/required-items/RequiredItem';
import {
    useChecklistData,
    useInvalidateChecklistQuery,
} from 'components/required-checklist/useChecklistData';
import { CONNECT_WITH_STRIPE_LINK } from 'constants/links';
import { posthogEvents } from 'constants/posthog-events';
import { usePosthog } from 'customHooks/usePosthog';

const RequiredConnectAccount = () => {
    const { pushEvent } = usePosthog();
    const { invalidateChecklistQuery } = useInvalidateChecklistQuery();
    const { checklist } = useChecklistData();
    const { connectPayoutAccount } = checklist;
    return (
        <RequiredItem.Root>
            <RequiredItem.TextContent className="gap-6 sm:gap-0">
                <div className="flex w-full flex-col items-start gap-3">
                    <RequiredItem.RequiredItemDuration>5 min</RequiredItem.RequiredItemDuration>
                    <div>
                        <RequiredItem.Title>Connect payout method</RequiredItem.Title>
                        <RequiredItem.Description>
                            Securely link your bank account or debit card to publish your campaign
                            and withdraw online donations. Required to go live.
                        </RequiredItem.Description>
                    </div>
                </div>
                {connectPayoutAccount ? (
                    <RequiredItem.CompletedIndicator />
                ) : (
                    <div className="flex gap-2">
                        <ConnectAccountDialog
                            onOpenChange={open => {
                                if (!open) {
                                    invalidateChecklistQuery();
                                }
                            }}
                        >
                            <RequiredItem.PrimaryButton
                                onClick={() =>
                                    pushEvent(posthogEvents.DASHBOARD_CHECKLIST_ITEM_SELECTED, {
                                        checklistItem: 'connectPayoutAccount',
                                    })
                                }
                            >
                                Connect account
                            </RequiredItem.PrimaryButton>
                        </ConnectAccountDialog>
                        <RequiredItem.SecondaryButton
                            onClick={() => window.open(CONNECT_WITH_STRIPE_LINK, '_blank')}
                        >
                            Learn more <FontAwesomeIcon icon={faExternalLink} />
                        </RequiredItem.SecondaryButton>
                    </div>
                )}
            </RequiredItem.TextContent>
            <RequiredItem.Image
                desktopSrc="/images/graphics/homepage-checklist/connectAccountDesktop.png"
                mobileSrc="/images/graphics/homepage-checklist/connectAccountMobile.png"
            />
        </RequiredItem.Root>
    );
};

export { RequiredConnectAccount };
